import { addLocale, locale as primeLocale } from "primereact/api";

// German locale for PrimeReact
const deLocale = {
	startsWith: "Beginnt mit",
	contains: "Enthält",
	notContains: "Enthält nicht",
	endsWith: "Endet mit",
	equals: "Gleich",
	notEquals: "Nicht gleich",
	noFilter: "Kein Filter",
	lt: "Kleiner als",
	lte: "Kleiner als oder gleich",
	gt: "Größer als",
	gte: "Größer als oder gleich",
	dateIs: "Datum ist",
	dateIsNot: "Datum ist nicht",
	dateBefore: "Datum ist vor",
	dateAfter: "Datum ist nach",
	clear: "Löschen",
	apply: "Anwenden",
	matchAll: "Alle übereinstimmen",
	matchAny: "Beliebige übereinstimmen",
	addRule: "Regel hinzufügen",
	removeRule: "Regel entfernen",
	accept: "Ja",
	reject: "Nein",
	choose: "Auswählen",
	upload: "Hochladen",
	cancel: "Abbrechen",
	dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
	dayNamesShort: ["Son", "Mon", "Die", "Mit", "Don", "Fre", "Sam"],
	dayNamesMin: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
	monthNames: [
		"Januar",
		"Februar",
		"März",
		"April",
		"Mai",
		"Juni",
		"Juli",
		"August",
		"September",
		"Oktober",
		"November",
		"Dezember",
	],
	monthNamesShort: [
		"Jan",
		"Feb",
		"Mär",
		"Apr",
		"Mai",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Okt",
		"Nov",
		"Dez",
	],
	today: "Heute",
	weekHeader: "Woche",
	firstDayOfWeek: 1,
	dateFormat: "dd.mm.yy",
	weak: "Schwach",
	medium: "Mittel",
	strong: "Stark",
	passwordPrompt: "Passwort eingeben",
	emptyFilterMessage: "Keine Ergebnisse gefunden",
	emptyMessage: "Keine verfügbaren Optionen",
};

// English locale is already built into PrimeReact as default
const enLocale = {};

export const initPrimeReactLocale = (language: string) => {
	if (language === "de") {
		addLocale("de", deLocale);
		primeLocale("de");
	} else {
		// English is the default
		primeLocale("en");
	}
};

export { deLocale, enLocale };
